import React, { useEffect, useState } from "react";
import SelectInput from "../../Global Functions/selectInput";
import { Link, useNavigate } from "react-router-dom";
import MainLayout from "../../Layout/mainLayout";
import TextInput from "../../Global Functions/textInput";
import { addNews } from "../../Redux/Actions/newsAction";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCityList,
  viewCountryListPagination,
  viewStateListPagination,
} from "../../Redux/Actions/settingsActions";
import AddImage from "../../Global Functions/addImage";
import { getProjectList } from "../../Redux/Actions/projectActions";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { viewCategoryList } from "../../Redux/Actions/categoryActions";
import ImageShowerModal from "../../Global Functions/imageShowerModal";

const AddNews = () => {
  const [newsData, setNewsData] = useState({
    title: "",
    description: "",
    url: "",
    type: "",
    news_link: "",
    start_date: "",
    end_date: "",
    country: "",
    city: "",
    state: "",
  });

  const [selection, setSelection] = useState("");
  const navigate = useNavigate();

  const uploadOptions = ["file", "url"];

  const categoryOptions = ["trending", "what's new", "luxury"];

  const dispatch = useDispatch();

  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { projects } = useSelector((state) => state.projects || {});

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setNewsData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const filteredNewsData = newsData
        ? Object.fromEntries(
            Object.entries(newsData).filter(([key, value]) => Boolean(value))
          )
        : {};
      const response = await dispatch(addNews(filteredNewsData));
      if (response.statusCode === 200) {
        navigate("/news_and_articles");
      }
    } catch (error) {}
  };

  const handleFileUpload = async (event) => {
    const uploadedFile = event.target.files[0];

    const inputId = event.target.id;

    if (!uploadedFile) return;

    const responseUrl = await AddImage(uploadedFile);

    if (responseUrl) {
      setNewsData((prevData) => ({
        ...prevData,
        url: responseUrl,
        type: inputId === "image" ? "image" : "video",
      }));
    }
  };

  useEffect(() => {
    dispatch(viewCountryListPagination());

    if (newsData.country) {
      dispatch(viewStateListPagination({ country: newsData.country }));
    }

    if (newsData.state) {
      const cityData = {
        state: newsData.state,
        country: newsData.country,
        page: 1,
        limit: 200,
      };
      dispatch(viewCityList(cityData));
    }
  }, [newsData.country, newsData.state, dispatch]);

  useEffect(() => {
    dispatch(getEnums());
    const categoryData = {
      page: 1,
      limit: 100,
    };
    dispatch(viewCategoryList(categoryData));
    const projectStatus = enumsData?.data?.ProjectStatus
      ? Object.values(enumsData.data.ProjectStatus)
      : [
          "requested",
          "approved",
          "declined",
          "published",
          "unpublished",
          "sold",
        ];
    const projectData = {
      status: projectStatus,
      page: 1,
      limit: 500,
      is_deleted: false,
    };

    dispatch(getProjectList(projectData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <MainLayout>
      <div
        style={{
          padding: "0px 20px",
          background: "white",
          borderRadius: "25px",
          gridColumn: "2/7",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h1>Add News/Article</h1>
          <Link to="/news_and_articles">
            <button className="button-class">View News List</button>
          </Link>
        </div>
        <form>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <TextInput
                label="Title"
                value={newsData.title}
                name="title"
                required={true}
                type="text"
                placeholder="Enter Title"
                onChange={handleAddChange}
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <SelectInput
                label="Select Country"
                placeholder="Select An Option"
                name="country"
                value={newsData.country} 
                onChange={handleAddChange}
                options={
                  Array.isArray(countryList?.data)
                    ? countryList.data.map((country) => ({
                        label: country.country_name,
                        value: country._id,
                      }))
                    : []
                }
              ></SelectInput>
            </div>
          </div>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <SelectInput
                label="Select State"
                placeholder="Select An Option"
                onChange={handleAddChange}
                disabled={!newsData.country}
                name="state"
                value={newsData.state} // Add this line
                options={
                  Array.isArray(states?.data)
                    ? states.data.map((state) => ({
                        label: state.state_name,
                        value: state._id,
                      }))
                    : []
                }
              />
            </div>
            <div style={{ width: "50%" }}>
              <SelectInput
                label="Select City"
                placeholder="Select An Option"
                onChange={handleAddChange}
                disabled={!newsData.state}
                name="city"
                value={newsData.city} // Add this line
                options={
                  Array.isArray(cities?.data)
                    ? cities.data.map((city) => ({
                        label: city.city_name,
                        value: city._id,
                      }))
                    : []
                }
              />
            </div>
          </div>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <TextInput
                label="Start Date"
                onChange={handleAddChange}
                name="start_date"
                type="date"
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                label="End Date"
                onChange={handleAddChange}
                name="end_date"
                type="date"
              ></TextInput>
            </div>
          </div>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <TextInput
                required={true}
                name="description"
                onChange={handleAddChange}
                value={newsData.description}
                label="Description"
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <SelectInput
                placeholder="Select an Option"
                onChange={handleAddChange}
                name="project"
                label="Select Project"
                value={newsData.project}
                options={
                  Array.isArray(projects?.data)
                    ? projects.data.map((project) => ({
                        label: project.project_name,
                        value: project._id,
                      }))
                    : []
                }
              ></SelectInput>
            </div>
          </div>
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ width: "50%" }}>
              <SelectInput
                placeholder="Select an Option"
                onChange={handleAddChange}
                name="category"
                label="Select Category"
                value={newsData.category}
                // options={
                //   Array.isArray(categories?.data)
                //     ? categories.data.map((cat) => ({
                //         label: cat.name,
                //         value: cat._id,
                //       }))
                //     : []
                // }
                options={
                  Array.isArray(categoryOptions)
                    ? categoryOptions.map((category) => ({
                        label:
                          category.charAt(0).toUpperCase() + category.slice(1),
                        value: category,
                      }))
                    : []
                }
              ></SelectInput>
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                label="Enter News Link"
                placeholder="Add Link"
                onChange={handleAddChange}
                name="news_link"
              ></TextInput>
            </div>
          </div>
          <div style={{ width: "50%" }}>
            <SelectInput
              placeholder="Select To Upload"
              onChange={(event) => setSelection(event.target.value)}
              label="Select File/URL"
              value={selection}
              options={
                Array.isArray(uploadOptions)
                  ? uploadOptions.map((cat) => ({
                      label: cat.toUpperCase(),
                      value: cat,
                    }))
                  : []
              }
            ></SelectInput>
          </div>

          {selection === "file" ? (
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
              }}
            >
              <div style={{ width: "50%" }}>
                <TextInput
                  forImage={true}
                  type="file"
                  disabled={newsData.url ? true : false}
                  span="Add Image"
                  id="image"
                  onChange={(event) => {
                    handleFileUpload(event);
                  }}
                  for="image"
                  label="Click to Upload Image"
                />
                {newsData.url && newsData.type === "image" ? (
                  <ImageShowerModal
                    file={newsData.url}
                    onClick={() =>
                      setNewsData((prevData) => ({
                        ...prevData,
                        url: "",
                        type: "",
                      }))
                    }
                  />
                ) : null}
              </div>
              <div style={{ width: "50%" }}>
                <TextInput
                  forImage={true}
                  type="file"
                  span="Add Video"
                  disabled={newsData.url ? true : false}
                  onChange={(event) => {
                    handleFileUpload(event);
                  }}
                  id="video"
                  for="video"
                  label="Click to Upload Video"
                />
                {newsData.url && newsData.type === "video" ? (
                  <ImageShowerModal
                    file={newsData.url}
                    onClick={() =>
                      setNewsData((prevData) => ({
                        ...prevData,
                        url: "",
                        type: "",
                      }))
                    }
                  />
                ) : null}
              </div>
            </div>
          ) : selection === "url" ? (
            <TextInput
              name="url"
              onChange={handleAddChange}
              value={newsData.url}
              label="Enter News URL"
            />
          ) : null}

          <div className="span2 flex-end margin-h-10">
            <Link to="/news_and_articles">
              <button className="button-class-white">Cancel</button>
            </Link>
            <button className="button-class" onClick={handleSubmit}>
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddNews;
